import styled from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
    `,

    "ContentDiv": styled.div`
        display: flex;
        flex-direction: column;
        gap: 40px;
        padding: 24px;
    `,

    "HeaderDiv": styled.div`
        display: flex;
        flex-direction: column;
        gap: 20px;

        & > h2 {
            ${({ theme }) => theme.font["medium-regular"]};
            line-height: 22px;
        }

        & > p {
            ${({ theme }) => theme.font["tiny-regular"]};
        }
    `,
    "ContentElement": styled.div`
        display: flex;
        flex-direction: column;
        gap: 4px;

        & > p {
            display: flex;
            gap: 6px;
            ${({ theme }) => theme.font["small-regular"]};
            color: ${({ theme }) => theme.color["grey4"]};

            & > span {
                ${({ theme }) => theme.font["small-semibold"]};
                color: ${({ theme }) => theme.color["red"]};
            }
        }
    `,
    "TitleDiv": styled.div`
        display: flex;
        align-items: center;
        gap: 8px;

        & > h2 {
            ${({ theme }) => theme.font["xxlarge-bold"]};
            word-break: break-word;
        }

        & > p {
            ${({ theme }) => theme.font["xtiny-semibold"]};
            color: ${({ theme }) => theme.color["white"]};
            background-color: ${({ theme }) => theme.color["red"]};
            padding: 2px 5px;
            border-radius: 9999px;
        }
    `,

    "Area": styled.div`
        display: flex;
        flex-direction: column;
        gap: 12px;

        & > h2 {
            width: 100%;
            ${({ theme }) => theme.font["xlarge-bold"]};
            padding-bottom: 12px;
            border-bottom: 1px solid ${({ theme }) => theme.color["black"]};
        }
    `,

    "EventList": styled.div`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
    "EventElement": styled.button`
        position: relative;
        display: flex;
        padding: 16px;
        border-radius: 8px;

        & > img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center center;
            border-radius: 8px;
        }
    `,
    "ShadowDiv": styled.div`
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgb(0,0,0,0.4);
        border-radius: 8px;
    `,
    "EventTitleDiv": styled.div`
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 4px;
        z-index: 1;

        & > h1 {
            color: ${({ theme }) => theme.color["white"]};
            ${({ theme }) => theme.font["large-semibold"]};
            text-align: left;
        }

        & > p {
            color: ${({ theme }) => theme.color["white"]};
            ${({ theme }) => theme.font["small-regular"]};
        }

        & > h2 {
            color: ${({ theme, $state }) => $state === 3 ? theme.color["grey3"] : theme.color["white"]};
            ${({ theme }) => theme.font["small-semibold"]};
        }
    `,
    "EventControlDiv": styled.div`
        width: 72px;
        min-width: 72px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: end;
        z-index: 1;

        & > p {
            color: ${({ theme }) => theme.color["white"]};
            ${({ theme }) => theme.font["xtiny-regular"]};
            padding: 4px 8px;
            border-radius: 9px;

            background-color: ${({ theme, $type }) => {
            if ($type === 1) return theme.color["red"]
            else if ($type === 2) return theme.color["orange"]
            else if ($type === 3) return theme.color["blue"]
            else if ($type === 4) return theme.color["green"]
            else if ($type === 5) return theme.color["grey4"]
        }};
        }

        & > button {
            width: 100%;
            background-color: ${({ theme }) => theme.color["black"]};
            ${({ theme }) => theme.font["xsmall-semibold"]};
            color: ${({ theme }) => theme.color["white"]};
            border: 1px solid ${({ theme }) => theme.color["white"]};
            border-radius: 4px;
            padding: 4px 0;
        }
    `,

    "Option": styled.p`
        width: 100%;
        ${({ theme }) => theme.font["small-regular"]};
        margin-top: 8px;
    `
}